/**
 * Recreates the deck's cover motif (ppt/media/image11.png): rows of spaced-out "/docker" and "/next" mono glyphs
 * sweeping diagonally. Drawn procedurally in SVG so nothing heavy ships to the phone.
 */
export function Motif() {
  const rows = 22;
  const words = ['/docker/', '/next/'];
  return (
    <div className="motif" aria-hidden="true">
      <svg viewBox="0 0 400 360" preserveAspectRatio="xMaxYMin slice" width="100%" height="100%">
        {Array.from({ length: rows }, (_, r) => {
          const word = words[r % 2];
          const t = r / rows;
          const spread = 18 + t * 26; // letters fan out further down the sweep
          const x0 = 400 - 30 - t * 260;
          return (
            <text
              key={r}
              y={14 + r * 16}
              fill="#AAC4F8"
              opacity={0.18 + 0.5 * (1 - t)}
              style={{ fontFamily: "'IBM Plex Mono', monospace", fontSize: 12 }}
            >
              {word.split('').map((ch, i) => (
                <tspan key={i} x={x0 + i * spread * (0.6 + t)}>
                  {ch}
                </tspan>
              ))}
            </text>
          );
        })}
      </svg>
    </div>
  );
}
